goog.provide('el8.data.staffGroups');

goog.require('el8.model.base');
goog.require('el8.model.identify');
goog.require('el8.service.urls');
goog.require('el8.util.workspace');

/**
 * NOTE: Because of the IW breakup, these staff groups
 * may or may not belong to this practice, since there can be threads
 * with members from other practices in a given chart.
 */
el8.data.staffGroups = (function() {

    // Model of a staff group
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDeleteable();
    _class.addStringProperty('name', true);
    _class.addIntProperty('practiceId');
    _class.addBoolean('elationGroup');
    _class.addBoolean('inWorkspace', false, true);

    // Array of staff user ID's
    _class.addProperty('userIds', true);

    _class.prototype.isUserMember = function(userId) {
        return (this.getUserIds().indexOf(userId) !== -1);
    };
    _class.prototype.hasPhysicianMember = function() {
        var userIds = this.getUserIds();
        for (var i=0; i<userIds.length; i++) {
            var user = el8.data.referencedUsers.getById(userIds[i]);
            if (user.isPhysician()) { return true; }
        }
        return false;
    };
    _class.prototype.hasStaffMember = function() {
        var userIds = this.getUserIds();
        for (var i=0; i<userIds.length; i++) {
            var user = el8.data.referencedUsers.getById(userIds[i]);
            if (user.isOfficeStaff()) { return true; }
        }
        return false;
    };

    _class.prototype.getActiveMembers = function() {
        return _.compact(this.getUserIds().map(function(staffId) {
            var user = el8.data.practiceUsers.getById(staffId);
            return (user.isActive()) ? user : null;
        }));
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        mapped['users'] = this.getActiveMembers().map(function(user) {
            return user.asSoyMap();
        });

        return mapped;
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        items: [],
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('staffGroups', [item.getId()]),
                async: opts.async,
                success: successCb,
                error: errorCb
            });
        },
        urlFn: function(id) { return el8.service.urls.get('staffGroups', [id]); },
        urlLoad: function() { return el8.service.urls.get('staffGroups'); }
    });

    var super_all = that.all;
    that.all = function() {
        return super_all.call(that).filter(function(m) {
            return m.getPracticeId() === el8.data.currPractice.getId();
        });
    };

    var super_getById = that.getById;
    that.getById = function(id, noFetch, includeDisabled) {
        var group = super_getById.call(that, id, noFetch);
        if (!group && includeDisabled) {
            return that.getDeletedById(id);
        }
        return group;
    };

    that.getGroupsForUser = function(userId) {
        var all = that.all();
        var r = [];
        for (var i=0; i<all.length; i++) {
            if (all[i].isUserMember(userId)) {
                r.push(all[i]);
            }
        }
        return r;
    };

    that.getGroupsForUserGroup = function(userGroup) {
        if (userGroup === 'physicians') {
            return that.all().filter(function(g) {
                return g.hasPhysicianMember();
            });
        } else if (userGroup === 'staff') {
            return that.all().filter(function(g) {
                return g.hasStaffMember();
            });
        } else if (userGroup === 'all') {
            return that.all();
        }
        return [];
    };

    // arg can either be a single id, or an array of id's
    that.allExcept = function(arg) {

        var all = that.all();
        if (!arg) { return all; }

        var exceptIdMap = {};
        if (arg.length === undefined) {
            exceptIdMap[arg] = true;
        } else {
            for (var i=0; i<arg.length; i++) {
                exceptIdMap[arg[i]] = true;
            }
        }
        var rGroups = [];
        for (var i=0; i<all.length; i++) {
            if (!exceptIdMap[all[i].getId()]) {
                rGroups.push(all[i]);
            }
        }
        return rGroups;
    };

    // Prepare for workspaces awareness
    el8.util.workspace.bindToDataModelUpdates(that);

    // Workspace aware version of the above functions (safe for use with or without workspace)
    that.getGroupsForUserInWorkspace = el8.util.workspace.filteringWrapper(that.getGroupsForUser)
    that.getGroupsForUserGroupInWorkspace = el8.util.workspace.filteringWrapper(that.getGroupsForUserGroup)
    that.allInWorkspace = el8.util.workspace.filteringWrapper(that.all);

    return that;
})();
